export const DEFAULT_WORKSPACE = 'main'; // TODO: V2 - this should really be "DEFAULT_WORKSPACE_NAME" since "workspace" is now generally referred to as the full object in fga which includes the org
export const DEFAULT_WORKERGROUP_NAME = 'default';

// Reserved workspaceId for the per-org Org Leader workspace (epic INFRA-9919).
// Customer-facing creation paths reject this id via WORKSPACE_ID_BANNED_LIST.
export const ORG_LEADER_WORKSPACE_ID = 'org';

/**
 * These are the allowed values from Stream, for the estimatedIngestGB/day
 * Ref: https://bitbucket.org/cribl/cribl/src/486c02229869ec25f332f83fda6b4371e338b8b6/src/share/apitypes.ts#lines-4488
 */
export const ALLOWED_ESTIMATED_INGEST_GBS = [
  250,
  500,
  750,
  1024,
  2048,
  3072,
  4096,
  5120,
  7168,
  9600,
  10240,
  13312,
  15360,
];

// This is set in metronome.
export const METRONOME_WGROUP_KEY = 'workergroup';

export const WorkspaceOperations = {
  sync: 'sync',
  hibernate: 'hibernate',
  wake: 'wake',
};

export const CERTIFICATE_VENDOR_SUPPORTED = ['google-public-ca', 'pebble'];
export const AWS_REGIONS = [
  'us-west-2',
  'us-east-1',
  'eu-central-1',
  'eu-west-2',
  'ap-southeast-2',
  'ca-central-1',
  'us-east-2',
  'eu-central-2',
  'ap-southeast-1',
  'ap-northeast-1',
  'sa-east-1',
  'eu-west-1',
  'eu-west-3',
];
export const WORKSPACE_ID_MIN_LEN = 4;
export const WORKSPACE_ID_MAX_LEN = 41;
export const WORKSPACE_ID_REGEX_PATTERN = '^[a-z0-9]*$';
export const WORKSPACE_TAG_LIMIT = 3;
export const DEFAULT_MAX_WORKSPACES = 5;
export const TAG_LENGTH_LIMIT = 20;
export const FQDN_ID_LENGTH_LIMIT = 64;

export const LOCK_EXPIRY_MS = 60 * 60 * 1000; // 1 hour lock expiry
export const WORKSPACE_CONFIG_LOCK_EXPIRY_MS = 10 * 60 * 1000; // 10 minute in-request config lock expiry

/**
 * Channels customers may choose in Maestro and set via the v4 workspace API.
 * Internal channels (rapid, rd, pre-ga, …) are assigned by admins through the
 * admin PATCH `channelSubscription` field instead.
 */
export const SettableReleaseChannel = {
  stable: 'stable',
  regular: 'regular',
} as const;

export type SettableReleaseChannel = (typeof SettableReleaseChannel)[keyof typeof SettableReleaseChannel];

export const ReadonlyReleaseChannel = {
  internal: 'internal',
} as const;

export type ReadonlyReleaseChannel = (typeof ReadonlyReleaseChannel)[keyof typeof ReadonlyReleaseChannel];

export const ReleaseChannel = {
  ...SettableReleaseChannel,
  ...ReadonlyReleaseChannel,
} as const;

export type ReleaseChannel = SettableReleaseChannel | ReadonlyReleaseChannel;
